import { ManageRoleFormValue } from './manage-role.interfaces';

export function createManageRoleFormValue(): ManageRoleFormValue {
  return {
    role_name: '',
    description: '',
  };
}
